import { AlertTriangle, RotateCcw } from 'lucide-react';

export interface BanepadDeviceErrorProps {
  /** Clears this tablet's local token and returns to the registration screen. */
  onReset: () => void;
}

/**
 * Physical-pad error state — shown when a stored device token no longer resolves
 * to an active paired device (revoked at the Sentralen, or otherwise invalid).
 * The only action is to clear the local token and re-register.
 */
export function BanepadDeviceError({ onReset }: BanepadDeviceErrorProps) {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-4 bg-bg-soft text-center">
      <div className="w-full max-w-md">
        <div className="flex justify-center mb-3" style={{ color: '#b45309' }}>
          <AlertTriangle size={40} />
        </div>
        <h1 className="font-display text-2xl font-bold text-ink mb-2">Paden er ikke koblet</h1>
        <p className="text-ink-2" style={{ fontSize: 15 }}>
          Denne paden er ikke koblet, eller tilkoblingen er tilbakekalt.
        </p>
      </div>

      <button
        onClick={onReset}
        className="btn-lime mt-8 justify-center"
        style={{ padding: '0.85rem 1.4rem', fontSize: 16 }}
        aria-label="Nullstill denne paden"
      >
        <RotateCcw size={18} /> Nullstill denne paden
      </button>
    </div>
  );
}
